import { render } from "./CampaignPerformanceMetrics.vue?vue&type=template&id=d340dc6c&scoped=true"
import script from "./CampaignPerformanceMetrics.vue?vue&type=script&lang=ts"
export * from "./CampaignPerformanceMetrics.vue?vue&type=script&lang=ts"

import "./CampaignPerformanceMetrics.vue?vue&type=style&index=0&id=d340dc6c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-d340dc6c"

export default script